<template>
  <div>

    <MemberAssignmentEditorModal
      ref="editor-modal"
      :member="member"
      :item="selected_item"

      @created="assignment_created"
      @updated="assignment_updated"
    />

    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2 mr-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('COMPANY.ADD_ASSIGNMENT')"
        variant="primary"
        @click="create_assignment"
      />
    </div>

    <memlist-static-table
      id="member-table"
      :fields="fields"
      :items="assignment_items"
      ref="member-table"
    >
      
      <template #cell(actions)="data">

        <div class='d-flex justify-content-end'>
          
          <memlist-table-button class="mr-2" @click="edit_row_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="delete_row_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />

        </div>
      </template>
    </memlist-static-table>


  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import MemberAssignmentEditorModal from '@/view/components/member_editor_v2/sections/member_assignments/MemberAssignmentEditorModal.vue';
import { mapGetters } from 'vuex';


export default {

  name: 'MemberAssignmentsTable',

  props: ['member','items','company','creating_member','view_only'],
  emits: ['delete','created', 'updated'],

  mixins: [ toasts ],

  components: {
    MemberAssignmentEditorModal
  },

  watch: {

  },

  computed: {
    ...mapGetters(['companies']),
    
    assignment_items() {
      return this.items.filter(i => i.company.type === 'assignment');
    },
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {
    get_parent_company(company_id) {
      const company = this.companies.find(i => i.company_id === company_id);
      console.log(company);

      return company;
    },
    assignment_created(item) {
      this.$emit('created', item);
    },
    assignment_updated(item) {
      this.$emit('updated', item);
    },
    
    create_assignment() {
      this.selected_item = {};
      
      this.$nextTick(()=>{
        this.$refs['editor-modal'].show();
      });
    },

    edit_row_clicked(item) {
      this.selected_item = item;
      
      this.$nextTick(()=>{
        this.$refs['editor-modal'].show();
      });
      
    },

    async delete_row_clicked(item) {
      const res = await axios.delete(`/member_company/${item.member_company_id}`);
      
      if (res.status === 204) {
        this.toastr('success', this.$t('COMMON.OK'), this.$t('COMPANY.ASSIGNMENT_DELETED'));
        this.$emit('deleted', item.member_company_id);
      }
      
    },
  },

  mounted() {

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }

  },

  data() {
    return {

      selected_item: null,

      fields: [
        {
          key: 'parent',
          label: this.$t('COMPANY.COMPANY'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4',
          formatter: (_, __, item) => {
            const company = this.get_parent_company(item.company_id);
            return company.parent_name;
          }
        },
        
        {
          key: 'company.name',
          label: this.$t('COMPANY.NAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'created_at',
          label: this.$t('COMMON.CREATED_AT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short5',
          thClass: 'td-short5',
          formatter: (_, __, item) => {
            return dayjs(item.reg_at).format('YYYY-MM-DD HH:mm');
          }
        },
        {
          key: 'vfdt',
          label: this.$t('MEMBERSHIP.VFDT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'vtdt',
          label: this.$t('MEMBERSHIP.VTDT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },

        {
          key: 'actions',
          label: '',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          mobile: true,
          sortable: false
        }
      ],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
